<form [formGroup]="addressForm" (ngSubmit)="saveAddress(inProgress)">
    <div class=" modal-header">
        <h5 class="modal-title d-flex align-items-center">
            <i class="bx bxs-map me-1 font-20 text-primary"></i>{{addressForm.value.id?'Update':'Add'}} Address
        </h5>
    </div>
    <div class="modal-body">
        <div class="row g-3 mb-2">
            <div class="col-md-6">
                <label for="line" class="form-label">Address Line<b class="text-secondary">*</b></label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-map'></i></span>
                    <input type="text" class="form-control ps-1" id="line" placeholder="Enter address line"
                        [ngClass]="{'is-invalid': submitted && a.line.errors}" formControlName="line" ngbAutofocus
                        autocomplete="off" />
                    <div class="invalid-feedback" *ngIf="submitted && a.line.errors">
                        <span *ngIf="a.line.errors.required">Please provide a valid address.</span>
                        <span *ngIf="a.line.errors.pattern">Invalid Address.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <label for="email" class="form-label">Email<b class="text-secondary">*</b></label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-envelope'></i></span>
                    <input type="text" class="form-control ps-1" id="email" placeholder="Enter email id"
                        [ngClass]="{'is-invalid': submitted && a.email.errors}" formControlName="email"
                        autocomplete="off" />
                    <div class="invalid-feedback" *ngIf="submitted && a.email.errors">
                        <span *ngIf="a.email.errors.required">Please provide a valid email.</span>
                        <span *ngIf="a.email.errors.pattern">Invalid email.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <label for="phone" class="form-label">Mobile Number<b class="text-secondary">*</b></label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-mobile-alt'></i></span>
                    <input type="text" class="form-control ps-1" id="phone" placeholder="Enter mobile number"
                        [ngClass]="{'is-invalid': submitted && a.phone.errors}" formControlName="phone"
                        autocomplete="off" />
                    <div class="invalid-feedback" *ngIf="submitted && a.phone.errors">
                        <span *ngIf="a.phone.errors.required">Please provide a valid mobile number.</span>
                        <span *ngIf="a.phone.errors.pattern">Invalid mobile number</span>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <label for="pin" class="form-label">PinCode<b class="text-secondary">*</b></label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-map-pin'></i></span>
                    <input type="text" class="form-control ps-1" id="pin" placeholder="Enter pincode"
                        [ngClass]="{'is-invalid': submitted && a.code.errors}" formControlName="code" autocomplete="off"
                        (blur)="getPostalData($event.target.value)" />
                    <div class="invalid-feedback" *ngIf="submitted && a.code.errors">
                        <span *ngIf="a.code.errors.required">Please provide a pincode .</span>
                        <span *ngIf="a.code.errors.pattern">Invalid pincode.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <label for="country" class="form-label">Country<b class="text-secondary">*</b></label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-globe-alt'></i></span>
                    <input type="text" class="form-control ps-1" id="country" placeholder="Enter country"
                        [ngClass]="{'is-invalid': submitted && a.country.errors}" formControlName="country"
                        autocomplete="off" />
                    <div class="invalid-feedback" *ngIf="submitted && a.country.errors">
                        <span *ngIf="a.country.errors.required">Please provide a valid country.</span>
                        <span *ngIf="a.country.errors.pattern">Invalid Country.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <label for="state" class="form-label">State<b class="text-secondary">*</b></label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-sitemap'></i></span>
                    <input type="text" class="form-control ps-1" id="state" placeholder="Enter State"
                        [ngClass]="{'is-invalid': submitted && a.state.errors}" formControlName="state"
                        autocomplete="off" />
                    <div class="invalid-feedback" *ngIf="submitted && a.state.errors">
                        <span *ngIf="a.state.errors.required">Please provide a valid state.</span>
                        <span *ngIf="a.state.errors.pattern">Invalid State.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <label for="district" class="form-label">District</label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-map-alt'></i></span>
                    <input type="text" class="form-control ps-1" id="district" placeholder="Enter district"
                        [ngClass]="{'is-invalid': submitted && a.district.errors}" formControlName="district"
                        autocomplete="off" />
                    <div class="invalid-feedback" *ngIf="submitted && a.district.errors">
                        <span *ngIf="a.district.errors.pattern">Invalid District.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <label for="city" class="form-label">City<b class="text-secondary">*</b></label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-map-pin'></i></span>
                    <input type="text" class="form-control ps-1" id="city" placeholder="Enter city"
                        [ngClass]="{'is-invalid': submitted && a.city.errors}" formControlName="city"
                        autocomplete="off" />
                    <div class="invalid-feedback" *ngIf="submitted && a.city.errors">
                        <span *ngIf="a.city.errors.required">Please provide a valid city.</span>
                        <span *ngIf="a.city.errors.pattern">Invalid City</span>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <label for="latitude" class="form-label">Latitude</label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-map-pin'></i></span>
                    <input type="text" class="form-control ps-1" id="latitude" placeholder="Enter latitude"
                        [ngClass]="{'is-invalid': submitted && a.latitude.errors}" formControlName="latitude"
                        autocomplete="off" />
                    <div class="invalid-feedback" *ngIf="submitted && a.latitude.errors">
                        <span *ngIf="a.latitude.errors.pattern">Only number is allowed</span>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <label for="longitude" class="form-label">Longitude</label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-map-pin'></i></span>
                    <input type="text" class="form-control ps-1" id="longitude" placeholder="Enter longitude"
                        [ngClass]="{'is-invalid': submitted && a.longitude.errors}" formControlName="longitude"
                        autocomplete="off" />
                    <div class="invalid-feedback" *ngIf="submitted && a.longitude.errors">
                        <span *ngIf="a.longitude.errors.pattern">Only number is allowed</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-auto ms-auto">
                <button type="submit" class="btn btn-secondary rcx-btn" #inProgress
                    [ngClass]="{'no-event':inProgress?.value=='true'}">
                    <ng-container *ngIf="inProgress?.value=='true'">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        {{addressForm.value.id?'Updating...':'Saving...'}}
                    </ng-container>
                    <ng-container *ngIf="inProgress?.value!='true'">
                        <i class="bx bx-save"></i>{{addressForm.value.id?'Save Changes':'Save'}}
                    </ng-container>
                </button>
            </div>
        </div>
    </div>
</form>